
export function convertToInt(input) {
  switch(typeof input) {
    case 'number':
      if (isNaN(input) || !isFinite(input))
        return 0;
      return Math.round(input);
    case 'string':
      var int = parseInt(input);
      if (isNaN(int) || !isFinite(int))
        return 0;
      return int;
    case 'boolean':
      return input ? 1 : 0;
    default:
      return 0;
  }
}